
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { addedProgressTags } from '@/api/other';
import { addedProgress } from '@/api/order';
import { UserModule } from '@/store/modules/user';
@Component({
  name: 'SupplementProgressDialog',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogVisible!: Boolean;
  @Prop({
    type: Object,
    default: () => ({}),
    required: true
  })
  orderDetail!: {};

  private list: any = null;

  private inputValue: any = '';

  private checkbox: boolean = false;

  created() {
    this.getTag(this.orderDetail);
  }

  tagClick(tag: any) {
    this.inputValue = this.inputValue + tag.name + ';';
  }

  save(orderDetail: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: orderDetail.order_service.servicer_company_id,
      added_progress_name: this.inputValue,
      is_customer_view: this.checkbox,
      order_id: orderDetail.order.id
    };
    if (orderDetail.order_service && orderDetail.order_service.id) {
      params.order_service_id = orderDetail.order_service.id;
    }
    if (orderDetail.order_task && orderDetail.order_task.id) {
      params.order_task_id = orderDetail.order_task.id;
    }
    addedProgress(params)
      .then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.close(true);
      })
      .catch((err) => {
        let msg = err.msg;
        this.showErrorMsg(msg)
      });
  }

  getTag(orderDetail: any) {
    const params = {
      company_id: orderDetail.order_service.servicer_company_id,
      user_id: UserModule.getUserId
    };
    addedProgressTags(params)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.list = data.list;
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }

  close(isRefresh:boolean) {
    this.inputValue = '';
    this.checkbox = false;
    this.$emit('close', isRefresh);
  }

  private customHeight = window.innerHeight * 0.4;
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: this.customHeight,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
